/**Import react section */
import React, { useState } from 'react';
import propTypes from 'prop-types'

/**Import MaterialUi section */
import { Grid } from '@material-ui/core'

/**Import components section */
import LateralPanel from '../../common/lateralPanel/LateralPanel';
import PanelHeader from '../../common/lateralPanel/PanelHeader'
import TextBox from '../../common/TextBox'

const AddLateralPanel = (props) => {

    /**Local store this component */
    const { onSaveButtonClick, onCloseButtonClick, isSaving } = props;

    const [salesRepresentativeModel, setSalesRepresentativeModel] = useState(defaultSalesRepresentative);

    /**On change properties */
    const onPropertyChange = event => {
        let { name, value } = event.target;
        setSalesRepresentativeModel({
            ...salesRepresentativeModel,
            [name]: value
        });

    }

    /**Verify if cam be sabed */
    const canBeSaved = () => {
        if (!salesRepresentativeModel) return false;
        if (salesRepresentativeModel.Name ? (salesRepresentativeModel.Name.length <= 0) : true) return false;
        return true;
    }

    const onSave = () => {
        if (props.onSaveButtonClick) {
            onSaveButtonClick(salesRepresentativeModel)
        }
    }

    return (
        <LateralPanel
            onClose={onCloseButtonClick}
        >
            <PanelHeader
                title={"Add sales representative"}
                onCloseButtonClick={onCloseButtonClick}
                isModeSaved={true}
                canBeSaved={canBeSaved()}
                onSaveButtonClick={onSave}
                isSaving={isSaving}
            />
            <div style={{ padding: "20px" }}>
                <Grid container >
                    <Grid item xs={12}>
                        <TextBox
                            active={true}
                            disabled={isSaving}
                            fullWidth
                            autoFocus
                            name="Name"
                            variant="outlined"
                            margin="dense"
                            label="Name"
                            onChange={onPropertyChange}
                            value={salesRepresentativeModel ? salesRepresentativeModel.Name : ""}
                        />

                    </Grid>
                </Grid>
            </div>

        </LateralPanel>
    )
}

const defaultSalesRepresentative = {
    Name: '',
}

/**Proptypes this component */
AddLateralPanel.propTypes = {
    /**
	 * On close lateral menu
	 */
    onCloseButtonClick: propTypes.func.isRequired,
    /**
    * invoke function for add new sales representative
    */
    onSaveButtonClick: propTypes.func.isRequired,
    /**
    * Determinate is saving when add sales representative
    */
    isSaving: propTypes.func.isRequired,
}


AddLateralPanel.defaultProps = {
    onCloseButtonClick: () =>
        console.warn('Callback [onCloseButtonClick] no defined'),
    onSaveButtonClick: () =>
        console.warn('Callback [onSaveButtonClick] no defined'),
    isSaving: false
}

export default AddLateralPanel
